export const EN_LETTERS = [
  [
    {
      name: 'Q',
    },
    {
      name: 'W',
    },
    {
      name: 'E',
    },
    {
      name: 'R',
    },
    {
      name: 'T',
    },
    {
      name: 'Y',
    },
    {
      name: 'U',
    },
    {
      name: 'I',
    },
    {
      name: 'O',
    },
    {
      name: 'P',
    },
  ],
  [
    {
      name: 'A',
    },
    {
      name: 'S',
    },
    {
      name: 'D',
    },
    {
      name: 'F',
    },
    {
      name: 'G',
    },
    {
      name: 'H',
    },
    {
      name: 'J',
    },
    {
      name: 'K',
    },
    {
      name: 'L',
    },
  ],
  [
    {
      name: 'Z',
    },
    {
      name: 'X',
    },
    {
      name: 'C',
    },
    {
      name: 'V',
    },
    {
      name: 'B',
    },
    {
      name: 'N',
    },
    {
      name: 'M',
    },
  ],
];
